import { useState } from "react";

// Shared clipboard button: copies `value`, flips to a "Copied"
// confirmation for a beat, then resets. Used by the API-key reveal
// (ApiKeys) and the MCP endpoint row (ConnectedApps) so the copy
// affordance behaves identically wherever a secret/URL is shown.
//
// A failed/blocked clipboard write (insecure origin, denied permission)
// surfaces as "Copy failed" rather than a silent no-op — for the
// one-time key secret the caller mustn't believe a copy succeeded when it
// didn't; the value stays visible for manual selection.
export function CopyButton({
  value,
  className = "btn secondary",
  label = "Copy",
}: {
  value: string;
  className?: string;
  label?: string;
}) {
  const [state, setState] = useState<"idle" | "ok" | "err">("idle");
  const flash = (s: "ok" | "err") => {
    setState(s);
    setTimeout(() => setState("idle"), 1500);
  };
  return (
    <button
      type="button"
      className={className}
      onClick={async () => {
        try {
          if (!navigator.clipboard) throw new Error("clipboard unavailable");
          await navigator.clipboard.writeText(value);
          flash("ok");
        } catch {
          flash("err");
        }
      }}
    >
      {state === "ok" ? "Copied" : state === "err" ? "Copy failed" : label}
    </button>
  );
}
